import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalFooter } from 'react-bootstrap';
import styled from 'styled-components';

import type { IDeleteDatabaseItemModalData } from '@/hooks/types';

import { Button } from '@/components/common';
import { useAppDispatch } from '@/hooks';
import { deleteDatabaseItem } from '@/store/slices/resourcesSlice';

interface IDatabaseItemDeleteModalProps {
  modalData: IDeleteDatabaseItemModalData;
  handleClose: () => void;
}

const DatabaseItemDeleteModal = ({ modalData, handleClose }: IDatabaseItemDeleteModalProps): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onDelete = () => {
    handleClose();
    dispatch(deleteDatabaseItem(modalData));
  };

  return (
    <>
      <ModalBody>
        <p>
          {modalData.itemsId.length > 1
            ? t('resources.modals.databaseMultipleItemsDeleteWarning', { count: modalData.itemsId.length })
            : t`resources.modals.databaseItemDeleteWarning`}
        </p>
      </ModalBody>
      <StyledModalFooter>
        <StyledButton color="blueOutline" onClick={handleClose}>
          {t`common.btnNo`}
        </StyledButton>
        <StyledButton color="blue" onClick={onDelete}>
          {t`common.btnYes`}
        </StyledButton>
      </StyledModalFooter>
    </>
  );
};

export { DatabaseItemDeleteModal };

const StyledButton = styled(Button)`
  flex: 1;
  margin: 0;
`;

const StyledModalFooter = styled(ModalFooter)`
  gap: 16px;
  justify-content: center;
  padding: 12px 0;
`;
